import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

export const Nav = () => {
  const { lang, setLang, t } = useLang();
  const links = [
    { href: "#about", key: "about" },
    { href: "#services", key: "services" },
    { href: "#market", key: "market" },
    { href: "#contact", key: "contact" },
  ];

  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1.1, delay: 1.4, ease: [0.76, 0, 0.24, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#0A0A0A]/70 border-b border-white/10"
      data-testid="site-nav"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16 flex items-center justify-between h-16">
        <a href="#top" className="group" data-testid="nav-logo">
          <div className="flex items-baseline gap-2">
            <span className="font-serif italic text-lg text-[#C5A059]">Felica</span>
            <span className="font-sans text-[10px] tracking-[0.32em] uppercase text-[#A1A1AA] group-hover:text-[#F4F4F0] transition-colors">Invest / SRL</span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-10" aria-label="Primary">
          {links.map((l) => (
            <a
              key={l.key}
              href={l.href}
              className="nav-link font-sans text-[11px] tracking-[0.28em] uppercase text-[#F4F4F0]/80 hover:text-[#F4F4F0]"
              data-testid={`nav-link-${l.key}`}
            >
              {t(`nav.${l.key}`)}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4" data-testid="lang-toggle">
          <button
            onClick={() => setLang("it")}
            className={`font-sans text-[11px] tracking-[0.24em] uppercase transition-colors ${
              lang === "it" ? "text-[#C5A059]" : "text-[#52525B] hover:text-[#F4F4F0]"
            }`}
            data-testid="lang-it"
            aria-pressed={lang === "it"}
          >
            IT
          </button>
          <span className="text-[#52525B]">/</span>
          <button
            onClick={() => setLang("en")}
            className={`font-sans text-[11px] tracking-[0.24em] uppercase transition-colors ${
              lang === "en" ? "text-[#C5A059]" : "text-[#52525B] hover:text-[#F4F4F0]"
            }`}
            data-testid="lang-en"
            aria-pressed={lang === "en"}
          >
            EN
          </button>
        </div>
      </div>
    </motion.header>
  );
};
